import Pikaday from 'pikaday';
import $ from 'jquery';

const datepickerInit = () => {
    $('.datepicker-pikaday').each(function () {
        // eslint-disable-next-line no-unused-vars
        const datepicker = new Pikaday({
            field: $(this)[0],
            format: 'DD/MM/YYYY',
            showDaysInNextAndPreviousMonths: true
        });
    });
};

$(() => {
    datepickerInit();
});



// WEBPACK FOOTER //
// ./src/components/form-elements/datepicker/c-datepicker.js